<div class="zint-base-card d-flex justify-content-between w-100">
  <span>On create, set CRM record owner to active user
    <small class="text-sup" role="button" matTooltip="Help" (click)="toggleOwnerHelp()">
      <i class="fas fa-circle-info text-vivid-blue"></i>
    </small>
  </span>
  <mat-slide-toggle [color]="'primary'" [(ngModel)]="updateObjectOwnerFlag" (ngModelChange)="handleToggleUpdateObjectOwnerFlag()">
  </mat-slide-toggle>
</div>

@if (pubMethods.hasData(teamsAndUsers) && (allUsers.length || allTeams.length)) {
  <div class="mt-3">
    <zint-permissions [allUsers]="allUsers" [allTeams]="allTeams" [existingTeams]="existingPermissions.organisations" [existingUsers]="existingPermissions.users"
    (onPermissionChange)="handlePermissionsEvent($event)"></zint-permissions>
  </div>
  }

<div class="zint-base-card zint-card-light mt-3 d-flex flex-gap-05 align-items-baseline">
  <i class="fas fa-circle-info"></i>
  <span>Superusers have full administrative access to the integration settings, so there is no need to grant them additional
  permissions here.</span>
</div>

@if (showOwnerHelpModal) {
  <zint-modal [modalConfig]="ownerHelpModalConfig" [modalContent]="ownerHelpModalContent"></zint-modal>
}